import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, Card, Button, Spinner } from "react-bootstrap";
import Joi from "joi-browser";
import FormComponent from "./common/formComponent";
import { login, getCurrentUser } from "../services/authService";
import { Redirect } from "react-router-dom";

class Login extends FormComponent {
  state = {
    data: { email: "", password: "" },
    errors: {},
    processing: false,
  };

  schema = {
    email: Joi.string().email().required().label("Email"),
    password: Joi.string().required().label("Password"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    try {
      await login(this.state.data);
      window.location = "/dashboard";
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  render() {
    if (getCurrentUser()) return <Redirect to="/dashboard" />;
    const { data, errors, processing } = this.state;

    return (
      <Card className="col-md-4 mt-5 mx-auto" id="login">
        <Card.Body>
          <Form onSubmit={this.handleSubmit}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                name="email"
                onChange={this.handleChange}
                value={data.email}
                size="sm"
                type="email"
                autoFocus
                autoComplete="off"
                placeholder="Enter email"
              />
              {errors.email && <span className="text-danger">{errors.email}</span>}
              <Form.Text className="text-muted">We'll never share your email with anyone else.</Form.Text>
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                name="password"
                onChange={this.handleChange}
                value={data.password}
                size="sm"
                type="password"
                placeholder="Password"
              />
              {errors.password && <span className="text-danger">{errors.password}</span>}
            </Form.Group>
            <Button disabled={this.validate() || processing} type="submit" className="main-color-bg" block>
              {processing && (
                <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
              )}
              Login
            </Button>
          </Form>
          <Link to="/reset-password" className="float-right mt-3">
            <small>Forgot Password?</small>
          </Link>
        </Card.Body>
      </Card>
    );
  }
}

export default Login;
